"use client";

import { useState, useTransition } from "react";

import { ChevronUpCircle } from "lucide-react";

import { Button } from "@kit/ui/button";

import { voteIssueAction } from "../lib/server/server-actions";
import { DownVoteButton } from "./downvote-button";

export function UpVoteButton(props: {
  votes: number;
  disabled: boolean;
  issueId: string;
}) {
  const [pending, startTransition] = useTransition();
  const [upvoted, setUpvoted] = useState(false);

  if (upvoted) {
    return <DownVoteButton {...props} votes={props.votes + 1} />;
  }

  return (
    <Button
      disabled={props.disabled || pending}
      variant={"outline"}
      size={"sm"}
      className={"flex items-center space-x-1 px-2 font-semibold"}
      onClick={() => {
        startTransition(async () => {
          await voteIssueAction({
            issueId: props.issueId,
            direction: "up",
          });

          setUpvoted(true);
        });
      }}
    >
      <ChevronUpCircle className={"fill-primary text-primary-foreground h-5"} />
      <span>{props.votes}</span>
    </Button>
  );
}
